/**
 * Formats a parsed calendar event's start time for display on the public
 * Events page (KBT-176). Kept as a small pure function, separate from the
 * ical parsing/expansion logic, so it's easy to unit test on its own.
 */
export function formatEventWhen(event) {
  if (!event?.start) return '';

  const dateLabel = event.start.toLocaleDateString('en-US', {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
  });

  if (event.allDay) return dateLabel;

  const timeLabel = event.start.toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
  });

  return `${dateLabel}  ·  ${timeLabel}`;
}
